import { render, staticRenderFns } from "./DriveFileDeleted.vue?vue&type=template&id=79622311&scoped=true"
import script from "./DriveFileDeleted.vue?vue&type=script&lang=js"
export * from "./DriveFileDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79622311",
  null
  
)

export default component.exports